module.exports = __webpack_public_path__ + "img/gs.e2171766.svg";